// const flowTypes = {
//   //订单充值
//   Deposit: { text: 'Depósito de Pedido ' },
//   //订单成功提现
//   Withdrawal: { text: 'Saque do Pedido' },
//   //提现中冻结金额
//   WithdrawalFrozen: { text: 'Saque do Pedido' },
//   //提现失败解冻金额
//   WithdrawalRelease: { text: 'Quantia Descongelada no Saque' },
//   //现金直充
//   CashRecharge: { text: 'Recarga em Dinheiro' },
//   //彩金加款
//   BonusRecharge: { text: 'Adição de Bônus' },
//   //彩金扣款
//   BonusDebit: { text: 'Dedução de Bônus' },

//   //代理返佣
//   AgentCommission: { text: 'Comissão de Agente' },
//   //代理返现
//   AgentRebate: { text: 'Reembolso de Agente' },
//   //充值活动奖励
//   DepositReward: { text: 'Recompensa de Promoção de Depósito' },
//   //充值赠送奖励
//   DepositBonus: { text: 'Recompensa de Bônus de Depósito' },
//   //兑换码奖励
//   RedeemReward: { text: 'Código de Resgate' },
//   //拼多多奖励
//   PddReward: { text: 'Recompensa PDD' },
//   //PWA奖励
//   PwaReward: { text: 'Recompensa PWA' },
//   //激活奖励
//   ActivationReward: { text: 'Recompensa de Ativação' },
//   //红包雨奖励
//   RedEnvelopeRainReward: {
//     text: 'Recompensa de Chuva de Envelope Vermelho',
//   },
//   //留存奖励
//   RetainReward: { text: 'Recompensa de Retenção' },
//   //VIP奖励
//   VipReward: { text: 'Recompensa VIP' },
//   //等级奖励
//   LevelReward: { text: 'Recompensa de Nível' },
//   //救济金
//   AidReward: { text: 'Fundo de Auxílio' },
//   //大转盘
//   SuperWheelReward: { text: 'Recompensa da Roleta Super' },
//   //用户返现
//   UserRebateReward: { text: 'Recompensa de Cashback' },
//   //邀请奖励
//   InviteeReward: { text: 'Recompensa para Convidados' },
//   //宝箱奖励
//   TreasureBoxReward: { text: 'Recompensa do Baú do Tesouro' },
//   //神秘彩金
//   MysteryBonusReward: { text: 'Recompensa de Bônus Misterioso' },
//   //投注
//   Bet: { text: 'Apostas' },
//   //结算
//   Settle: { text: 'Liquidação' },
//   //投注结算
//   BetSettle: { text: 'Apostas e Liquidação' },
//   //投注取消
//   BetCancel: { text: 'Aposta Cancelada' },
//   //投注修改
//   BetAdjust: { text: 'Aposta Modificada' },
//   //投注转入
//   BetCredit: { text: 'Transferência de Entrada' },
//   //投注转出
//   BetDebit: { text: 'Transferência de Saída' },
// }

// const options = [
//   {
//     text: 'Dados de Hoje',
//     buttonText: 'Hoje',
//     values: 1,
//   },
//   {
//     text: 'Dados de Ontem',
//     buttonText: 'Ontem',
//     values: 2,
//   },
//   {
//     text: 'Dados das últimas 7 dias',
//     buttonText: 'Últimos 7 Dias',
//     values: 3,
//   },
//   {
//     text: 'Dados das últimas 15 dias',
//     buttonText: 'Últimos 15 Dias',
//     values: 4,
//   },
//   {
//     text: 'Dados das últimas 30 dias',
//     buttonText: 'Últimos 30 Dias',
//     values: 5,
//   },
// ]

// const types = [
//   {
//     buttonText: 'Depósito',
//     values: 'Deposit',
//   },
//   {
//     buttonText: 'Saque',
//     values: 'Withdrawal',
//   },
//   {
//     buttonText: 'Sistema',
//     values: 'System',
//   },
//   {
//     buttonText: 'Bônus',
//     values: 'Reward',
//   },
//   {
//     buttonText: 'Aposta',
//     values: 'Game',
//   },
// ]

// export { flowTypes, options, types }
export function getLabel(t: (key: string) => string) {
  return {
    flowTypes: {
      //订单充值
      Deposit: { text: t('Registro.constants.flowTypes.Deposit') },
      //订单成功提现
      Withdrawal: { text: t('Registro.constants.flowTypes.Withdrawal') },
      //提现中冻结金额
      WithdrawalFrozen: { text: t('Registro.constants.flowTypes.WithdrawalFrozen') },
      //提现失败解冻金额
      WithdrawalRelease: { text: t('Registro.constants.flowTypes.WithdrawalRelease') },
      //现金直充
      CashRecharge: { text: t('Registro.constants.flowTypes.CashRecharge') },
      //彩金加款
      BonusRecharge: { text: t('Registro.constants.flowTypes.BonusRecharge') },
      //彩金扣款
      BonusDebit: { text: t('Registro.constants.flowTypes.BonusDebit') },
    
      //代理返佣
      AgentCommission: { text: t('Registro.constants.flowTypes.AgentCommission') },
      //代理返现
      AgentRebate: { text: t('Registro.constants.flowTypes.AgentRebate') },
      //充值活动奖励
      DepositReward: { text: t('Registro.constants.flowTypes.DepositReward') },
      //充值赠送奖励
      DepositBonus: { text: t('Registro.constants.flowTypes.DepositBonus') },
      //兑换码奖励
      RedeemReward: { text: t('Registro.constants.flowTypes.RedeemReward') },
      //拼多多奖励
      PddReward: { text: t('Registro.constants.flowTypes.PddReward') },
      //PWA奖励
      PwaReward: { text: t('Registro.constants.flowTypes.PwaReward') },
      //激活奖励
      ActivationReward: { text: t('Registro.constants.flowTypes.ActivationReward') },
      //红包雨奖励
      RedEnvelopeRainReward: { text: t('Registro.constants.flowTypes.RedEnvelopeRainReward') },
      //留存奖励
      RetainReward: { text: t('Registro.constants.flowTypes.RetainReward') },
      //VIP奖励
      VipReward: { text: t('Registro.constants.flowTypes.VipReward') },
      //等级奖励
      LevelReward: { text: t('Registro.constants.flowTypes.LevelReward') },
      //救济金
      AidReward: { text: t('Registro.constants.flowTypes.AidReward') },
      //大转盘
      SuperWheelReward: { text: t('Registro.constants.flowTypes.SuperWheelReward') },
      //用户返现
      UserRebateReward: { text: t('Registro.constants.flowTypes.UserRebateReward') },
      //邀请奖励
      InviteeReward: { text: t('Registro.constants.flowTypes.InviteeReward') },
      //宝箱奖励
      TreasureBoxReward: { text: t('Registro.constants.flowTypes.TreasureBoxReward') },
      //神秘彩金
      MysteryBonusReward: { text: t('Registro.constants.flowTypes.MysteryBonusReward') },
      //投注
      Bet: { text: t('Registro.constants.flowTypes.Bet') },
      //结算
      Settle: { text: t('Registro.constants.flowTypes.Settle') },
      //投注结算
      BetSettle: { text: t('Registro.constants.flowTypes.BetSettle') },
      //投注取消
      BetCancel: { text: t('Registro.constants.flowTypes.BetCancel') },
      //投注修改
      BetAdjust: { text: t('Registro.constants.flowTypes.BetAdjust') },
      //投注转入
      BetCredit: { text: t('Registro.constants.flowTypes.BetCredit') },
      //投注转出
      BetDebit: { text: t('Registro.constants.flowTypes.BetDebit') },
    },
    options: [
      {
        text: t('Registro.constants.options.TodayData'),
        buttonText: 'Hoje',
        values: 1,
      },
      {
        text: t('Registro.constants.options.YesterdayData'),
        buttonText: 'Ontem',
        values: 2,
      },
      {
        text: t('Registro.constants.options.Last7DaysData'),
        buttonText: 'Últimos 7 Dias',
        values: 3,
      },
      {
        text: t('Registro.constants.options.Last15DaysData'),
        buttonText: 'Últimos 15 Dias',
        values: 4,
      },
      {
        text: t('Registro.constants.options.Last30DaysData'),
        buttonText: 'Últimos 30 Dias',
        values: 5,
      },
    ],
    types: [
      {
        buttonText: t('Registro.constants.types.Deposit'),
        values: 'Deposit',
      },
      {
        buttonText: t('Registro.constants.types.Withdrawal'),
        values: 'Withdrawal',
      },
      {
        buttonText: t('Registro.constants.types.System'),
        values: 'System',
      },
      {
        buttonText: t('Registro.constants.types.Reward'),
        values: 'Reward',
      },
      {
        buttonText: t('Registro.constants.types.Game'),
        values: 'Game',
      }
    ]
  };
}
